module.exports = {"index_newsletter_subscriptions":{"form":{"url":"https://docs.google.com/forms/d/1QEoHvQoPPazw3h904pjQGVL_-0sPKqfVwD8KZyAilbw","name_email":"entry.2018695432"},"background":"form_bg.jpg","comment_class":"grid-4 grid-tablet-3 grid-mobile-4 centered"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/hk/zh_hk/setting/index/setting.json
// module id = 620
// module chunks = 0 1 2 3 4 5